import { Controller } from '@hotwired/stimulus'
import * as Turbo from '@hotwired/turbo'
import { FetchRequest } from '@rails/request.js'
import DrawerFrameController from './drawer-frame'

export default class SubmissionIndexController extends Controller<HTMLElement> {
  declare initialSubmissionUrlValue: string
  declare readonly drawerFrameOutlet: DrawerFrameController
  declare readonly drawerSkeletonTarget: HTMLTemplateElement

  static outlets = ['drawer-frame']
  static targets = ['drawerSkeleton']
  static values = { initialSubmissionUrl: String }

  // Lifecycle methods

  connect() {
    this.element.addEventListener('click', this.#handleClick)
  }

  disconnect() {
    this.element.removeEventListener('click', this.#handleClick)
  }

  drawerFrameOutletConnected() {
    const initialSubmissionUrl = this.initialSubmissionUrlValue

    if (!initialSubmissionUrl) return

    // Clear the value to prevent potential re-fire in the event that
    // another drawer connects while the value is set
    this.initialSubmissionUrlValue = ''

    // Remove the `view` search param from the URL
    const url = new URL(window.location.href)
    url.searchParams.delete('view')
    history.replaceState(null, '', url)

    this.#openDrawerSkeleton(initialSubmissionUrl)
    new FetchRequest('get', initialSubmissionUrl, { responseKind: 'turbo-stream' }).perform()
  }

  // Private methods

  #getIdFromPath(submissionContainerPath?: string) {
    return submissionContainerPath?.match(/submission_containers\/([^/]+)/)?.at(1)
  }

  #handleClick = (event: Event) => {
    const link = (event.target as HTMLElement).closest<HTMLAnchorElement>('a[data-submission-link]')
    if (!link) return
    this.#openDrawerSkeleton(link.pathname)
  }

  #openDrawerSkeleton(submissionContainerPath: string) {
    // FIXME: Instead of using regex here, consider storing the Submission Container ID
    // as a data attribute on the link instead of parsing the URL.
    const containerId = this.#getIdFromPath(submissionContainerPath)
    if (!containerId) return

    const html = this.drawerSkeletonTarget.innerHTML.replaceAll('{{UUID}}', containerId)

    Turbo.renderStreamMessage(`
      <turbo-stream action="append" target="drawer-frame">
        <template>${html}</template>
      </turbo-stream>
    `)
  }
}
